import Grid from '@mui/material/Grid';
import React from 'react';
import Card, { CardItem } from '../Card/Card';

export type CardsViewProps = {
  cards: CardItem[];
};

export default function CardsView({ cards }: CardsViewProps) {
  return (
    <Grid container spacing={2}>
      {cards &&
        cards.map(card => (
          <Grid key={card.title} item xs={12} md={6} lg={4}>
            <Card item={card} key={card.title} />
          </Grid>
        ))}
    </Grid>
  );
}
